import * as React from "react";
import './FormButton.css'
import Icon from "../Icon/Icon";


interface IProps {
    btnText: string;
    classes: string;
    isLoading?: boolean
    click: () => void;
    icon?: string
}

export default class FormButton  extends React.Component<
    IProps
    > {

    public renderLoading = () => {
      return (
          <div id="wave">
              <span className="dot"/>
              <span className="dot"/>
              <span className="dot"/>
          </div>
      )
    };

    public renderIcon = () => {
        const {icon} = this.props;
        return icon?<div className="icon-container"> <Icon icon={icon}/> </div>: null;
    };

    public render() {
        const {btnText, click, classes, isLoading, icon} = this.props;
         return(<>
            <div className={"btn " + classes}  onClick={click}>
                <div className="btn-text"> {btnText} </div>
                {icon? this.renderIcon() : null}
                {isLoading? this.renderLoading(): null}
            </div>
             {}
        </>);
    };
}


// WEBPACK FOOTER //
// ./src/components/FormButton/FormButton.tsx